export interface INewBuildingPromo {
  /** Текст акции **/
  newBuildingLabel: string;
  /** Тип акции **/
  promoType: EPromoType;
}

export enum EPromoType {
  /** Банк **/
  Bank = 'bank',
  /** Бонусы **/
  Bonus = 'bonus',
  /** Скидки **/
  Discount = 'discount',
  /** Ипотека **/
  Mortgage = 'mortgage',
  /** Материнский капитал **/
  MaternalCapital = 'maternalCapital',
  /** Военная ипотека **/
  MilitaryMortgage = 'militaryMortgage',
}
